import { Button, Input, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
export default function AiArtifactEditor({
  initialValue,
  onSave,
}: {
  initialValue: string;
  onSave: (value: string) => Promise<void>;
}) {
  const [value, setValue] = useState(initialValue);
  const [saving, setSaving] = useState(false);
  useEffect(() => setValue(initialValue), [initialValue]);
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Typography.Text type="secondary">Cada salvamento cria uma revisão imutável.</Typography.Text>
      <Input.TextArea rows={12} value={value} onChange={(event) => setValue(event.target.value)} />
      <Button
        loading={saving}
        onClick={async () => {
          setSaving(true);
          try {
            await onSave(value);
          } finally {
            setSaving(false);
          }
        }}
      >
        Salvar nova revisão
      </Button>
    </Space>
  );
}
